import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';

interface Prop {
    orders: any[];
    commodity: any;
    pkg: any;
}
interface State {}

@injectIntl()
export default class OrderProduct extends Base<Prop, State> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {}

    render() {
        const { orders = [], commodity = {}, pkg = {} } = this.props;
        return (
            <>
                {orders?.map((order, index) => {
                    return (
                        <div className="this_box" key={order.id}>
                            <div className="m-orderItem">
                                <div className="row-1" style={{ paddingBottom: 0 }}>
                                    <div style={{ width: '50%', float: 'left' }}>
                                        <div className="tips_orderid">
                                            <FormattedMessage id="order-created-time" />
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>{order.createTime}</div>
                                    </div>
                                    <div style={{ width: '50%', float: 'left' }}>
                                        <div className="tips_orderid">
                                            <FormattedMessage id="order-number" />
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>{order.code}</div>
                                    </div>
                                </div>
                                <div className="this_explain">
                                    <h2>
                                        <FormattedMessage id="delivery.information" />
                                    </h2>
                                    <p></p>
                                    <p> {order.shipFullAddress}</p>
                                </div>
                                <div style={{ borderBottom: '1px solid #eee', margin: '20px 0', width: '93%' }}></div>
                                <div className="row-2">
                                    <div className="goodImg f-fl">
                                        <img src={commodity.mainImg} width="64" height="64" />
                                    </div>
                                    <div className="goodInfo f-fl">
                                        <div className="goodName">{pkg.name}</div>
                                        {/* <!-- <div className="goodNum"></div> -->  */}
                                        <div
                                            className="goodName"
                                            style={{
                                                position: 'absolute',
                                                bottom: '5px',
                                                right: '16px',
                                                textAlign: 'right',
                                                color: '#666',
                                            }}
                                        ></div>
                                    </div>
                                    <div className="goodStatus f-fr" style={{ color: '#666', fontSize: '12px' }}>
                                        <div>
                                            <span>
                                                <FormattedMessage id="order.count" />
                                            </span>
                                            <span>1</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 套餐包含产品 -->  */}
                            <div className="m-goodItems" style={{ display: 'block' }} id="showComboProduct_content">
                                {/* <!--产品套餐属性-->  */}
                                {order?.spuArr?.map((spu: any) => {
                                    return spu?.skuArr?.map((sku: any, skuIndex: number) => {
                                        return (
                                            <div style={{ padding: '0 10px' }} key={skuIndex}>
                                                <div
                                                    className="row-2"
                                                    style={{ paddingTop: '5px', paddingLeft: '36px', position: 'relative' }}
                                                >
                                                    <div className="goodImg f-fl">
                                                        <img
                                                            src={sku.imgUrl}
                                                            width="32"
                                                            height="32"
                                                            style={{
                                                                borderRadius: '4px',
                                                                overflow: 'hidden',
                                                                border: '1px solid #eee',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="goodInfo f-fl u3" style={{ width: '70%', marginTop: '0px' }}>
                                                        <div
                                                            className="goodName"
                                                            style={{ fontSize: '12px', color: '#aaa', marginLeft: '16px' }}
                                                        >
                                                            {spu.spuName}
                                                        </div>
                                                        <div
                                                            className="goodName"
                                                            style={{ fontSize: '12px', color: '#aaa', marginLeft: '16px' }}
                                                        >
                                                            <div style={{ width: '80%', float: 'left' }}>
                                                                {sku?.attributeValueArr
                                                                    ?.map((attr: any) => {
                                                                        return (
                                                                            attr.attributeName + ':' + attr.attributeValueLabel
                                                                        );
                                                                    })
                                                                    .join(' ')}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    width: '20%',
                                                                    float: 'left',
                                                                    textAlign: 'right',
                                                                    right: '6px',
                                                                    fontSize: '12px',
                                                                    color: '#666',
                                                                }}
                                                            >
                                                                x {sku.qty}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    });
                                })}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    }
}
